export default __webpack_public_path__ + "static/media/product-placeholder.9504d64c.png";